import SourceSerializer from "./SourceSerializer";
import EnteredUserSerializer from "./EnteredUserSerializer";
import { parseMcleodDate, formatDateForMcleod, formatDate } from "../utils/dateHelpers";

export default class OfferSerializer {
  static serialize(data) {
    const payload = {
      __type: data.offerType,
      ...data,
      id: data.id,
      order_id: data.orderId,
      company_id: data.companyId,
      amount: data.amount,
      amount_n: data.amount,
      capacity: data.capacity ? "1" : "0",
      phoenix_declined_reason_id: data.declineReason,
      carrier_name: data.carrierName,
      payee_id: data.carrierId,
      comments: data.comments,
      counter_offer: data.counterOffer,
      icc_number: data.icc_number,
      dot_number: data.dot_number,
      equipment_type_id: data.equipmentTypeId,
      miles_to_origin: data.miles ? `${data.miles}` : "",
      prv_appt: formatDateForMcleod(data.prevApptTime),
      expected_empty_time: formatDateForMcleod(data.expEmptyTime),
      contact_name: data.contactName,
      contact_phone: data.contactPhone,
      mobile_phone: data.mobilePhone,
      modified_date: formatDateForMcleod(formatDate(data.modifiedDate, "yyyyMMddHHmmsszz00")),
      offer_date: formatDateForMcleod(data.offerDate),
      status: data.status,
      approved_status: data.approvedStatus ? data.approvedStatus : "",
      tractor_city: data.city ? data.city : "",
      tractor_city_id: data.cityId ? data.cityId.toString() : "",
      tractor_state: data.state ? data.state : "",
      order_total_chg: data.orderTotalCharge,
      movement_id: data.movementId,
      entered_user_id: data.enteredUserId,
      enteredUserIdRow: data.entered_user_id ? EnteredUserSerializer.serialize(data.entered_user_id_row) : null,
      source: data.source,
      sourceRow: data.source ? SourceSerializer.serialize(data.source_row) : null
    };

    const customProperties = [
      "orderId",
      "companyId",
      "declineReason",
      "carrierName",
      "carrierId",
      "counterOffer",
      "equipmentTypeId",
      "miles",
      "prevApptTime",
      "expEmptyTime",
      "contactName",
      "contactPhone",
      "mobilePhone",
      "modifiedDate",
      "offerDate",
      "city",
      "cityId",
      "state",
      "orderTotalCharge",
      "movementId",
      "enteredUserId",
      "sourceRow",
      "approvedStatus"
    ];

    customProperties.forEach(prop => delete payload[prop]);
    return payload;
  }

  static deSerialize(data) {
    return {
      __type: data.offerType,
      ...data,
      id: data.id,
      orderId: data.order_id,
      companyId: data.company_id,
      amount: data.amount,
      capacity: data.capacity === "1" ? true : false,
      declineReason: data.phoenix_declined_reason_id,
      pipelineStatus: data.pipeline_status,
      carrierStatus: data.carrier_status,
      carrierName: data.carrier_name,
      carrierId: data.payee_id,
      comments: data.comments,
      representativeName: data.entered_user_id ? data.entered_user_id_row.name : data.source_row.descr,
      counterOffer: data.counter_offer,
      icc_number: data.icc_number,
      dot_number: data.dot_number,
      equipmentTypeId: data.equipment_type_id,
      miles: data.miles_to_origin,
      prevApptTime: parseMcleodDate(data.prv_appt),
      expEmptyTime: parseMcleodDate(data.expected_empty_time),
      contactName: data.contact_name,
      contactPhone: data.contact_phone,
      mobilePhone: data.mobile_phone,
      modifiedDate: parseMcleodDate(data.modified_date),
      offerDate: parseMcleodDate(data.offer_date),
      lastUpdatedDate: parseMcleodDate(data.modified_date || data.offer_date),
      status: data.status,
      highwayStatus: data.highway_status,
      highwayRuleAssessment: data.highway_rule_assessment,
      city: data.tractor_city,
      cityId: data.tractor_city_id,
      state: data.tractor_state,
      cityState: data.tractor_city && data.tractor_state ? `${data.tractor_city}, ${data.tractor_state}` : null,
      orderTotalCharge: data.order_total_chg,
      movementId: data.movement_id,
      approvedStatus: `${data.approved_status}`,
      enteredUserId: data.entered_user_id,
      enteredUserIdRow: data.entered_user_id ? EnteredUserSerializer.deSerialize(data.entered_user_id_row) : null,
      source: data.source,
      sourceRow: data.source ? SourceSerializer.deSerialize(data.source_row) : null
    };
  }
}